import { Field, Form, Formik } from "formik";
import React from "react";
import { useSelector } from "../../store";
import { Grid } from "@mui/material";
import { Inputs } from "../formInputs";
import { Base } from "../base";
import Attachment from "../../types/attachment";

interface Props {
  handleSubmit: (values: Attachment) => void;
  handleCancel: () => void;
}

const EditAttachmentForm: React.FC<Props> = (props) => {
  const { handleSubmit, handleCancel } = props;
  const { attachment, status } = useSelector((store) => store.attachments);
  return (
    <Formik initialValues={attachment} onSubmit={handleSubmit}>
      <Form noValidate>
        <Grid container>
          <Grid size={12}>
            <Field name="name" label="Name" component={Inputs.Text} required />
          </Grid>
          <Grid size={12}>
            <Field name="note" label="Note" component={Inputs.TextArea} />
          </Grid>
          <Grid size={12}>
            <Grid container justifyContent={"space-between"}>
              <Base.Button
                text="Cancel"
                type="secondary"
                onClick={handleCancel}
              />
              <Inputs.Submit isSubmitting={status === "loading"} />
            </Grid>
          </Grid>
        </Grid>
      </Form>
    </Formik>
  );
};

export default EditAttachmentForm;
